import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ConfigProvider, Spin } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { appTheme } from './theme'
import AppLayout from './components/AppLayout'
import { StoreManageRoute, SuperAdminRoute } from './components/AdminRoute'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider, useAuth } from './context/AuthContext'

const Login = lazy(() => import('./pages/Login'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const AssetList = lazy(() => import('./pages/AssetList'))
const AssetForm = lazy(() => import('./pages/AssetForm'))
const Stores = lazy(() => import('./pages/Stores'))
const Staff = lazy(() => import('./pages/Staff'))
const Settings = lazy(() => import('./pages/Settings'))
const Logs = lazy(() => import('./pages/Logs'))

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '200px auto' }} />
  }
  if (!user) return <Navigate to="/login" replace />
  return children
}

const LazyFallback = () => (
  <Spin size="large" style={{ display: 'block', margin: '200px auto' }} />
)

function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LazyFallback />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assets" element={<AssetList />} />
            <Route path="assets/add" element={<StoreManageRoute><AssetForm /></StoreManageRoute>} />
            <Route path="assets/edit/:serial_number" element={<StoreManageRoute><AssetForm /></StoreManageRoute>} />
            <Route path="stores" element={<SuperAdminRoute><Stores /></SuperAdminRoute>} />
            <Route path="staff" element={<StoreManageRoute><Staff /></StoreManageRoute>} />
            <Route path="settings" element={<StoreManageRoute><Settings /></StoreManageRoute>} />
            <Route path="logs" element={<SuperAdminRoute><Logs /></SuperAdminRoute>} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={appTheme}>
      <ErrorBoundary>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ErrorBoundary>
    </ConfigProvider>
  )
}

export default App
